<template>
  <div>
    <DropdownMenu>
      <DropdownMenuTrigger as-child>
        <Button
          variant="ghost"
          size="icon"
          class="size-10 rounded-md border border-gray-200 text-gray-500 hover:bg-gray-50 hover:text-gray-900"
        >
          <vue-feather type="more-horizontal" class="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem as-child>
          <router-link :to="`${route.fullPath}/edit`" data-track="clicked-edit-candidate-button">
            <vue-feather type="edit-2" class="pr-2 h-4 w-4" />
            Edit
          </router-link>
        </DropdownMenuItem>
        <DropdownMenuItem
          v-if="contact.recordType !== 'Teammate'"
          data-track="clicked-delete-candidate-button"
          @select="showContactDelete = true"
        >
          <vue-feather type="trash" class="pr-2 h-4 w-4" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>

    <ContactDelete
      v-if="showContactDelete"
      @handle-contact-delete="showContactDelete = false"
      @handle-contact-delete-cancel="showContactDelete = false"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import ContactDelete from './ContactDelete.vue';
import type { ContactDetail } from './ContactDetail';

defineProps<{
  contact: ContactDetail;
}>();

const route = useRoute();

const showContactDelete = ref(false);
</script>
